import { defineStore } from 'pinia'
import { getFeatureFlags } from '@/api/featureFlags'

/**
 * C 端全局功能开关（来源：/app/feature-flags，游客可访问）
 * - 首次使用时懒加载，全应用共享一次请求结果；
 * - 加载完成前/接口异常默认按「开启」兜底，保持后管配置缺失时的既有体验，
 *   避免弱网下入口闪烁消失。
 */
export const useFeatureStore = defineStore('feature', {
  state: () => ({
    /** AI 情感助理入口是否展示（默认开启，拉取到后管配置后以配置为准） */
    aiAssistantEnabled: true,
    loaded: false,
    loading: false
  }),
  actions: {
    /** 拉取全局功能开关；force=true 可在配置变更后主动刷新 */
    async loadFlags(force = false): Promise<void> {
      if ((this.loaded || this.loading) && !force) return
      this.loading = true
      try {
        const res = await getFeatureFlags()
        if (res?.data && typeof res.data.aiAssistantEnabled !== 'undefined') {
          this.aiAssistantEnabled = Number(res.data.aiAssistantEnabled) !== 0
          this.loaded = true
        }
      } catch {
        // 接口异常：保持默认开启兜底，不打扰用户（拦截器已有统一错误提示策略）
      } finally {
        this.loading = false
      }
    }
  }
})
